import script from "./head.vue?vue&type=script&setup=true&lang=js"
export * from "./head.vue?vue&type=script&setup=true&lang=js"

import "./head.vue?vue&type=style&index=0&id=eec8fea0&lang=scss"

const __exports__ = script;

export default __exports__